export const AXIOS_HEADER = { 
    'Content-Type': 'application/json', 
    'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MDUyODUzNTYsImV4cCI6MTYzNzQyNjE1NiwiaWQiOiI1IiwiZW1haWwiOiJpbmZvcm1hdGljYUBtZWRpYWFkZ28uY29tIiwiY29tcGFueUlkIjoiNSIsInJvbGVzIjpbIiJdfQ.B-ipCNmsJDov84QzPoQbnt0CkE5Zw26UHlF9vd4-k8rSyGbq_UH83D1XjFADpjzzyvq4kV4DattkL_37gJ1uk9rbTT4z89nJS8R_shEuilcc-0xiucrVLtOXcdSbEBN-rBdEo0pf6DdOMKYHSfMrbXJfrs2tYM6SlGG2K7i6n2nRraEAYL0qjspWccvtUVPws76TQVILIc-BryZFaUc5HipRuumUDqkf9om2DOPfmEUJRmn3cGPKx7qOWbDcHLlLRodpjhOiuP8EesbvWKmodha3Gc1BGvow-3avcZsm_r_jmj9e4OodG3TNV4yaJ3HtekfKQvtj20h04GUCXt4UvbOZyMxa7vbBMKhgu8W1UQT9hvTaxdu5_mELRIrC7TMR_SShZSQ8fDsGyBOQFXqxFeJaGBNERoXZGQ80Z1BJwFUqO78iZ_oJc8GRPEFazMDyVuSwKxACRhoBArhzdvp6U2dDWbKPyHqCAGNKUaY6g7KZES1fWb-iGiklzOGTLTkXHmeyDZJnT9iem1h_eWfs_3MuDliqL4m7xHKmxpCWxPDlPBgiG2SartlnJE-2FSYPeInSa-sggN_NjEX9b1OvEX8TvL5Ckdo7JwVn1KlVr4-LjcIZIYvB3CxcNmmQ6GcVXo-PjcEU8CqJtelwxO5kcJAP515kbKdFHl3LgalMd_w'
}

export const HOST_API = "https://eu1-api.leadgrease.com/";


export const options_format = {
    format_1: 'select',
    format_2: 'radio'
}



export const switch_css =/*css*/`
    .switch {
        position: relative;
        display: inline-block;
        width: 55px;
        height: 27px;
    }
    
    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }
    
    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }
    
    .slider:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 20px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    
    input:checked + .slider {
        background-color: gray;
    }
    
    input:focus + .slider {
        box-shadow: 0 0 1px gray;
    }
    
    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    
    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    
    .slider.round:before {
        border-radius: 50%;
    }
`

export const progressbar_css =/*css*/`
    /* Progress bar by step */
    .progressbar{
        display: flex;
        position: relative;
        z-index: 2;
      }
      .progressbar .step{
        /*float: left;*/
        width:calc(100%/3); /* Calc by javascript*/
        position: relative;
        text-align: center;
        
      }
      .progressbar .step .icon{
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ddd;
        display: block;
        text-align: center;
        margin: 0 auto 10px  auto;
        border-radius: 50%;
        background-color: white;
      }
      .progressbar .connector {
        position: absolute;
        width:100%;
        height:1px;
        background-color: #ddd;
        top: 15px;
        left: -50%;
        z-index: -1;
      }
      .progressbar .step:first-child .connector {
        width: 0;
      }
      .progressbar .step.active {
        color:green;
      }
      .progressbar .step.active .icon {
        border-color: green;
      }
      .progressbar .step.active + .step .connector {
        background-color: green;
      }


` 

export const spinner_css = /*css*/`
    .spinner-body{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #afafafab;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
    }
    .spinner-body .spinner {
        -webkit-animation: rotate 2s linear infinite;
                animation: rotate 2s linear infinite;
        z-index: 2000;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -25px 0 0 -25px;
        width: 50px;
        height: 50px;
    }
    .spinner-body .spinner .path {
        stroke: black;
        stroke-linecap: round;
        -webkit-animation: dash 1.5s ease-in-out infinite;
                animation: dash 1.5s ease-in-out infinite;
    }

    @-webkit-keyframes rotate {
        100% {
            -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
        }
    }

    @keyframes rotate {
        100% {
            -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
        }
    }
    @-webkit-keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

`;

export const modal_sponsors_css = /*css*/`
    .modal{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        display: none;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
      }
      .modal .modal-dialog{
        width: 700px;
        margin: 3% auto 0;
      }
      .modal .modal-title{
        margin-bottom: 0;
        line-height: 1.5;
        font-size: 1.2rem;
      }
      .modal .modal-content{
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
          pointer-events: auto;
          background-color: #fff;
          background-clip: padding-box;
          border: 1px solid rgba(0,0,0,.2);
          border-radius: .3rem;
          outline: 0;
          padding-bottom: 1em;
      }
      .modal.show{
        display: block;
        background-color:#00000087;
      }
      .modal .btn-close{
        background: none;
        border: none;
        position: absolute;
        right: 2px;
        top: 4px;

      }
      .modal .btn-close svg{
        
        width: 15px;
        height: 15px;

      }
      .modal .modal-header{
        padding: 0 0 0 2em;
        position: relative;
        min-height: 1.5em;
      }
      .modal .modal-body{
        padding: 1.5em 1.5em 0;
      }
      .modal .modal-footer{
        padding: 0 2em;
        display:flex;
        justify-content: flex-end;
      }
      .ml-2{
        margin-left: 1em;
      }
      .mr-2{
        margin-right:1em;
      }
      .modal .sponsors-title{
          font-weight: bold;
          font-size: 1.2em;
      }
      
      .modal .sponsor-list .spon{
          border-bottom: 1px solid #ccc;
          display:flex;
          justify-content: space-between;
      }
      .modal .sponsor-list .spon-title{
          color:black;
          font-weight: bold;
          font-size: 1.2em;
          margin:0.7em 0;
      }
      
      .modal .sponsor-list .spon .link-conditions{
          text-decoration: none;
          font-weight: bold;
          color:#638ef8;
      }
      
      .modal .sponsor-list .spon_r{
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          flex-direction: column;
          padding-bottom: 5%;
          
      } 
      .modal .sponsor-list .spon .checkbox {
          opacity: 0;
          position: absolute;
      }
      .modal .sponsor-list .spon .checkbox:checked + .label .ball {
          transform: translateX(23px);
      }
      .modal .sponsor-list .spon .checkbox:checked + .label  {
          background-color: #2196f3;
      }
      
      .modal .sponsor-list .spon .label {
            background-color: #ccc;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 50px;
            position: relative;
            padding: 5px;
            height: 26px;
            width: 50px;
      }
      .modal .sponsor-list .spon .ball {
          background-color: #fff;
          border-radius: 50%;
          position: absolute;
          top: 2px;
          left: 2px;
          height: 22px;
          width: 22px;
          transition: transform 0.3s linear;
      }

`;

export const component_switch_css = /*css*/`

    .switch[c-type='switch']{
        display:inline-block;
    }
    .switch[c-type='switch'] .checkbox {
        opacity: 0;
        position: absolute;
        
    }
    .switch[c-type='switch'] .checkbox:checked + .label .ball {
        transform: translateX(23px);
    }
    .switch[c-type='switch'] .checkbox:checked + .label  {
        background-color: #2196f3;
    }
    
    .switch[c-type='switch'] .label {
        background-color: #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 50px;
        position: relative;
        padding: 5px;
        height: 26px;
        width: 50px;
        
        transform-scale(2.2);
    }
    
    .switch[c-type='switch'] .ball {
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        top: 2px;
        left: 2px;
        height: 22px;
        width: 22px;
        transition: transform 0.3s linear;
    }

`;